import styles from './styles.module.scss';

export default function StatsCard({ title, data }) {
    return (
        <div className={styles.metricCard}>
            <h3>{title}</h3>
            <span>{data}</span>
        </div>
    );
}
